import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";
import type { GmailMessageDetail } from "../_types/gmail.types";

export const useEmailMessageQuery = (messageId: string | null) => {
  return useQuery({
    queryKey: ["gmail-message", messageId],
    queryFn: async (): Promise<GmailMessageDetail> => {
      const response = await axiosInstance.get<ApiResponse<GmailMessageDetail>>(
        `/v2/inbox/emails/messages/${messageId}`,
      );
      if (!response.data.data) {
        throw new Error("No message data");
      }
      return response.data.data;
    },
    enabled: Boolean(messageId),
  });
};
